import Box from '@mui/material/Box';

interface SimpleRowProps {
  children: [string, JSX.Element][];
}

const SimpleRow = ({ children }: SimpleRowProps) => (
  <Box
    // className={classes.root}
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    }}
  >
    {children.map(([key, Component]) => (<div key={key}>{Component}</div>))}
  </Box>
);

export default SimpleRow;
